import { ITabletData, TabletUsageTypeMode } from "api/types";

export const shouldHideUsageType = (tabletData?: ITabletData) => {
  return (
    !tabletData ||
    tabletData.whiteLabelMode ||
    tabletData.usageTypeMode === TabletUsageTypeMode.Med ||
    tabletData.usageTypeMode === TabletUsageTypeMode.Rec
  );
};

export const formatTabletUsageType = (
  tabletUsageType?: TabletUsageTypeMode
) => {
  if (!tabletUsageType) {
    return false;
  }
  switch (tabletUsageType) {
    case TabletUsageTypeMode.Med:
      return "Medicinal";
    case TabletUsageTypeMode.Rec:
      return "Recreational";
    case TabletUsageTypeMode.MedRec:
      return "Medicinal and Recreational";
    case TabletUsageTypeMode.Unset:
      return "Unset";
  }
};



// WEBPACK FOOTER //
// ./src/components/UsageTypeSelector/utils.ts